module.exports = __webpack_public_path__ + "static/media/summaryIcon.d4cbd26c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/summaryIcon.svg
// module id = 241
// module chunks = 0